import { render, staticRenderFns } from "./SPetshopAnimal.vue?vue&type=template&id=a3e598ec"
import script from "./SPetshopAnimal.vue?vue&type=script&lang=js"
export * from "./SPetshopAnimal.vue?vue&type=script&lang=js"
import style0 from "./SPetshopAnimal.vue?vue&type=style&index=0&id=a3e598ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports